import styled from 'styled-components';

interface IToogleButton {
  isBlocked:boolean;
  checked: boolean;
}

export const Switch = styled.div<IToogleButton>`
  position: relative;
  width: 32px;
  height: 18px;
  background: ${(props) => props.isBlocked ? '#D6D6D6' : '#D0DEE1'};
  border-radius: 10px;
  padding: 4px;
  transition: 300ms all;

  &:before {
    transition: 300ms all;
    content: "";
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 10px;
    top: 50%;
    left: 4px;
    background: ${(props) => props.isBlocked && !props.checked ? '#E3E3E3' : '#ffffff'};
    transform: translate(0, -50%);
  }
`;

export const Input = styled.input`
  display: none;

  &:checked + ${Switch} {
    background: #E02828;

    &:before {
      transform: translate(12px, -50%);
    }
  }
`;

export const Label = styled.label<IToogleButton>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: ${(props) => props.isBlocked ? 'not-allowed' : 'pointer'};
  opacity: ${(props) => props.isBlocked && props.checked ? '40%' : ''};
`;